module.exports = __webpack_public_path__ + "img/users-primary.0751dd91.svg";